import React from "react";

import ShareButtons from "../../../../utility/ShareButtons";
import FAQAccordion from "../../../../utility/FAQAccordion";
import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";

import CardDesign from "../../../../utility/serviceTemplateutility/CardDesign";
import { useCart } from "../../../../contextApi/cartContext";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import { useLanguage } from "../../../../contextApi/languageContext";
import { fatburning } from "../../../../text-files/weightloss&slimming/wieghtloss/fatburning.ts";
import { motion } from "framer-motion";
import ListDesign from "../../../../utility/serviceTemplateutility/ListDesign.jsx";
import BeforeAfterCarousel from "../../../../utility/serviceTemplateutility/BeforeAfterCarousel.jsx";
export default function FatBurningInjections() {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { addToCart } = useCart();
  const { language } = useLanguage();
  const content = fatburning[language];
  const shared = fatburning.shared;

  const product = {
    id: 1,
    title: "Fat Burning Injections",
    price: 599,
    description:
      "Fat burning injections target stubborn fat deposits without surgery. This non-surgical body contouring treatment effectively breaks down fat cells in problem areas like chin, abdomen, and thighs. The FDA-approved formula provides visible results with minimal downtime for a slimmer, more contoured appearance.",
  };
  const faqs = [
    { heading: "Frequently Asked Questions" },
    {
      question: "Are fat burner injections safe?",
      answer:
        "Yes, fat burner injections are generally safe when performed by a qualified professional, ensuring proper technique and aftercare to minimize risks.",
    },
    {
      question: "How long does a fat burning injection last?",
      answer:
        "The results of fat dissolving injections last a lifetime. The fat cells do not reoccur in the treated areas.",
    },
    {
      question: "What is the best injection for fat loss?",
      answer:
        "The best fat loss injection depends on individual needs, with popular options including Aqualyx and Kybella, which target stubborn fat areas effectively.",
    },
    {
      question: "Do fat dissolving injections really work?",
      answer:
        "Yes, fat-dissolving injections break down fat cells, which are then naturally eliminated by the body.",
    },
  ];

  const benefitsCheckList = [
    { text: "Targets stubborn fat in specific areas." },
    {
      text: "Non-surgical solution to define the jawline and reduce double chin.",
    },
    { text: "Subtle contouring to enhance facial harmony." },
    { text: "Effective for reducing lower belly fat." },
    { text: "Minimally invasive, non-surgical treatment." },
    { text: "Accelerates stomach fat reduction for quicker results." },
    { text: "Quick sessions with minimal downtime." },
    { text: "Delivers smooth, natural-looking results." },
    { text: "Permanent fat cell reduction in treated areas." },
    { text: "Boosts confidence with a sculpted appearance." },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const images = [
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Postnatal-Weight-Loss-4.webp",
      alt: "fat reduction treatments",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/110.webp",
      alt: "belly fat removal",
    },
    {
      src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/109.webp",
      alt: "fat dissolving injections",
    },
  ];

  const procedureSteps = [
    { heading: "Fat Burning Injections Procedure" },
    {
      title: "Consultation",
      description:
        "Your journey begins with a consultation and health assessment, including a Body Composition Analysis (BCA). In some cases, blood tests may be required to ensure your suitability for fat burning injections.",
      icon: "fa-solid fa-user-doctor",
      link: "https://elitebodyhome.com/blood-test-at-home-dubai/",
    },
    {
      title: "Marking the Treatment Area",
      description:
        "The areas where the injections will be administered are marked. This is usually where excess fat is most visible.",
      icon: "fa-solid fa-pen-ruler",
    },
    {
      title: "Injection Process",
      description:
        "The fat dissolving injections are performed using fine needles, ensuring minimal discomfort. Multiple sessions may be required depending on the desired outcome.",
      icon: "fa-solid fa-syringe",
    },
    {
      title: "Follow-Up Appointments",
      description:
        "Follow-up visits ensure you're progressing towards your goals, with adjustments to your treatment plan as needed.",
      icon: "fa-solid fa-calendar-check",
    },
  ];

  return (
    <>
      <title>Fat Burning Injections (Lipolysis) in Dubai - Fat Melting</title>
      <meta
        name="description"
        content="Fat burning injections (Lipolysis) target stubborn fat in areas like the belly and double chin. A safe, non-surgical fat reduction treatment in Dubai."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/fat-burning-injections/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Fat Burning Injections (Lipolysis) in Dubai - Fat Melting"
      />
      <meta
        property="og:description"
        content="Fat burning injections (Lipolysis) target stubborn fat in areas like the belly and double chin. A safe, non-surgical fat reduction treatment in Dubai."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/fat-burning-injections/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-20T08:48:17+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-106.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-106.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Fat Burning Injections" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Fat Burning Injections (Lipolysis) in Dubai - Fat Melting"
      />
      <meta
        name="twitter:description"
        content="Fat burning injections (Lipolysis) target stubborn fat in areas like the belly and double chin. A safe, non-surgical fat reduction treatment in Dubai."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-106.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <div className="container-fluid px-0 py-4">
          <div className="row justify-content-center">
            <div>
              <div
                className="rounded-4 overflow-hidden shadow-sm"
                style={{ border: "2px solid #c69933" }}
              >
                <div className="row g-0 align-items-stretch">
                  {/* Image Column - Left Side */}
                  <div className="col-lg-6">
                    <img
                      loading="lazy"
                      decoding="async"
                      src={shared.images.main}
                      className="img-fluid w-100 h-100 object-fit-cover"
                      alt="Aqualyx fat dissolving injections in Dubai | Elite Body Home"
                      style={{
                        minHeight: "400px",
                        maxHeight: "720px",
                      }}
                    />
                  </div>

                  {/* Content Column - Right Side */}
                  <div className="col-lg-6 d-flex align-items-center bg-white">
                    {language === "en" ? (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          Fat Burning Injections
                        </h1>
                        <p className="fs-5 text-secondary mb-4">
                          Eliminate stubborn fat deposits &amp; sculpt your
                          ideal body shape with our FDA-approved non-surgical
                          fat reduction treatments.
                        </p>
                      </div>
                    ) : (
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          حقن إذابة الدهون
                        </h1>
                        <p className="fs-5 text-secondary mb-4">
                          تخلّص من ترسّبات الدهون العنيدة وانحت شكل جسمك المثالي
                          مع علاجاتنا المعتمدة من هيئة الغذاء والدواء (FDA)
                          لتقليل الدهون بدون جراحة.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>
            <QuickNavigation />
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            <section id="treatment" class="container py-5">
              <div class="text-center mb-5">
                <h2 class="fw-bold title">Treatment Areas</h2>
              </div>
              <div class="row g-4">
                <div class="col-12 col-sm-6 col-lg-4">
                  <div class="h-100 text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/6.jpg"
                      class="card-img-top"
                      alt="double chin removal dubai"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Double Chin Removal</h5>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                  <div class="h-100  text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/1.jpg"
                      class="card-img-top"
                      alt="belly fat removal"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Belly Fat Removal</h5>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                  <div class="h-100  text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/2-1.jpg"
                      class="card-img-top"
                      alt="fat dissolving injections legs"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Thighs</h5>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                  <div class=" h-100 text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/3.jpg"
                      class="card-img-top"
                      alt="flanks fat removal"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Flanks (Love Handles)</h5>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                  <div class=" h-100 text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/4-1.jpg"
                      class="card-img-top"
                      alt="arms fat removal"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Upper Arms</h5>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-6 col-lg-4">
                  <div class=" h-100 text-center">
                    <img
                      src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/5-1.jpg"
                      class="card-img-top"
                      alt="back (bra bulge) fat removal"
                    />
                    <div class="card-body">
                      <h5 class="card-title">Back (Bra Bulge)</h5>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div className="container-fluid px-0">
              <div className="row g-0">
                <div className="col-12">
                  <div className="ratio ratio-16x9">
                    <iframe
                      src="https://www.youtube.com/embed/jJTsA7cuuxk"
                      title="Fat Dissolving Injections Explained"
                      allowFullScreen
                      className="w-100"
                      style={{ minHeight: "300px" }}
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
